export const COMPETITION_ID = "-ORjuIDf-8rGUJR9BgaN";
